import classNames from 'classnames';
import { EMDASH } from 'constants';

// Styles
import './TabularList.less';
import PropTypes from 'prop-types';

export default function TabularList({ className, data, indented }) {
  if (!data) {
    return null;
  }

  return (
    <div className={classNames('component-TabularList', 'w-full', className)}>
      {data.map((d, rowIndex) => (
        <div
          key={typeof d?.title === 'string' ? d?.title : rowIndex}
          className="border-b border-solid border-gray-200 grid grid-cols-[2fr_3fr] items-start"
        >
          <div
            className={classNames(
              'component-TabularList__content text-base font-medium text-[#000] pt-5 py-0 md:py-5 pr-12',
              {
                'pl-7': indented,
              },
            )}
          >
            {d?.titleRequired && <span className="text-red-500 mr-0.5">*</span>}
            {d?.title}
          </div>

          <div
            className={classNames('component-TabularList__content text-base text-gray-900 leading-relaxed', {
              'mr-7 pl-7 md:pl-12': indented,
              'pl-0 md:pl-12': !indented,
            })}
          >
            <span className="py-5 block">
              {d?.value === undefined || d?.value === null || d?.value === '' ? EMDASH : d?.value}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}

TabularList.propTypes = {
  indented: PropTypes.bool,
};

export const DetailBlock = ({ items }) => (
  <div className="flex flex-col gap-3 md:gap-1">
    {items.map(({ label, value }) => (
      <div key={label} className="flex flex-col md:flex-row md:justify-between md:gap-4">
        <span className="text-gray-500">{label}:</span>
        <span>{value}</span>
      </div>
    ))}
  </div>
);

DetailBlock.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.node,
    }),
  ).isRequired,
};
